module.exports = __webpack_public_path__ + "img/1.ebfd872e.png";